import { createConfirmation } from 'react-confirm';
import ConfirmDialog from './ConfirmDialog';
import AmountConfirmDialog from './AmountConfirmDialog';

/**
 * @param {string} confirmation 
 * @param {ConfirmDialogOptionProps} options 
 * @returns 
 */
export const confirm = (confirmation, options = {}) => {
  return createConfirmation(ConfirmDialog)({ confirmation, ...options });
};

/**
 * @param {string} confirmation 
 * @param {ConfirmDialogOptionProps} options 
 * @returns 
 */
export const confirmAmount = (confirmation, options = {}) => {
  return createConfirmation(AmountConfirmDialog)({ confirmation, ...options });
};

/**
 * @typedef {{
 *  okLabel?: string | React.Component,
 *  cancelLabel?: string | React.Component,
 *  title: string,
 *  show: boolean,
 *  proceed: (value: string) => void,
 *  dismiss: (value: string) => void,
 *  cancel:  (value: string) => void,
 *  enableEscape: boolean,
 *  message: string,
 *  hideCancel: boolean,
 *  hideOk: boolean,
 * }} ConfirmDialogOptionProps
 */